module.exports = {
  "dof-toast-wrapper": {
    "position": "fixed",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "dof-toast-inner": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgba(12,12,12,0.8)",
    "paddingTop": "26",
    "paddingRight": "64",
    "paddingBottom": "26",
    "paddingLeft": "64",
    "borderRadius": "16",
    "maxWidth": "640"
  },
  "dof-toast": {
    "maxWidth": "640",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "dof-toast-content": {
    "fontSize": "32",
    "color": "rgba(255,255,255,0.8)",
    "textAlign": "center"
  },
  "icon": {
    "width": "72",
    "height": "72",
    "marginBottom": "16"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-15b37ec4!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-toast/index.vue
// module id = 433
// module chunks = 0 1